import { render, staticRenderFns } from "./MultilangEditor.vue?vue&type=template&id=6c0bb6b6&scoped=true"
import script from "./MultilangEditor.vue?vue&type=script&lang=js"
export * from "./MultilangEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0bb6b6",
  null
  
)

export default component.exports